<template>
  <a-row type="flex">
    <a-col flex="300px" v-show="windowWidth" class="logo-box" @click="backHome">
      <img src="@/assets/logo.png" alt="" class="logo-img" />
    </a-col>
    <a-col flex="auto">
      <div class="menu">

        <a-menu :selectedKeys="current" mode="horizontal" @click="routerJump">
          <template v-for="item in menuItem">
            <!-- 判断是否有子菜单 -->
            <a-sub-menu
              v-if="item.children && item.children.length"
              :key="item.name"
              :title="item.title"
            >
              <template #icon>
                <component :is="$icons[item.icon]" />
              </template>
              <!-- 子菜单项 -->
              <a-menu-item
                v-for="subItem in item.children"
                :key="subItem.name"
                :path="subItem.path"
              >
                <template #icon>
                  <component :is="$icons[subItem.icon]" />
                </template>
                <span>{{ subItem.title }}</span>
              </a-menu-item>
            </a-sub-menu>

            <!-- 单一菜单项 -->
            <a-menu-item
              v-else
              :key="item.name"
              :path="item.path"
              style="min-width: 110px"
            >
              <template #icon>
                <component :is="$icons[item.icon]" />
              </template>
              <span>{{ item.title }}</span>
            </a-menu-item>
          </template>
        </a-menu>

        
      </div>
    </a-col>
    <a-col>
      <a-space class="user-info" v-if="isLogin">
          <a-button class="login-btn" type="primary" @click="onLogin('login')"
            >Login | Register</a-button
          >
        </a-space>

        <a-space class="user-info" v-else>
          <a-dropdown>
            <div>
              <span v-if="windowWidth" class="user-name">User Information</span>
              <a-avatar style="background-color: #1890ff">
                <template #icon><UserOutlined /></template>
              </a-avatar>
            </div>

            <template #overlay>
              <a-menu @click="onUserOperate">
                <a-menu-item key="user">
                  <SettingOutlined />
                  <span class="user-info-text">User Center</span>
                </a-menu-item>
                <a-menu-item key="pay">
                  <AlipayOutlined />
                  <span class="user-info-text">Membership renewal</span>
                </a-menu-item>
                <a-menu-item key="exit">
                  <LogoutOutlined /><span class="user-info-text">Exit</span>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </a-space>
    </a-col>
  </a-row>

  

  <ContactUs ref="contactUs" />
</template>

<script>
import { reactive, computed, ref, onMounted, getCurrentInstance } from "vue";
import { useMain } from "@/store/index";
import { useRouter, useRoute } from "vue-router";
import LocalStoreAPI from "@/utils/localStoreUtil";
import ContactUs from "@/views/home/ContactUs.vue";

export default {
  name: "Header",
  components: {
    ContactUs,
  },
  setup() {
    const { $message } =
      getCurrentInstance().appContext.config.globalProperties;
    const useStoreMain = useMain();
    const router = useRouter();
    const route = useRoute();
    const current = computed(() => {
      return [route.name];
    });
    const userId = useStoreMain.userId;
    const windowWidth = computed(() => {
      return useStoreMain.windowWidth >= 1100;
    });

    const menuItem = computed(() => {
      let MenuItemData = useStoreMain.getMenuItem.find(
        (item) => item.name == "home"
      );
      if (MenuItemData) {
        MenuItemData = MenuItemData.children.filter(
          (item) => item.name != "user" && item.name != "pay"
        );
      }
      console.log("菜单", MenuItemData);
      return MenuItemData;
    });

    const isLogin = computed(() => {
      let userId = useStoreMain.userInfo.id;
      return userId ? false : true;
    });
    const login = ref(null);
    const backHome = () => {
      console.log("返回首页");
    };

    /**导航栏点击 */
    const routerJump = ({ item, key, keyPath }) => {
      console.log("导航栏点击", item, key, keyPath);
      console.log({ name: key });
      if (key == "feedBack") {
        // router.push({ name: key, params: { page: `page` } });
        router.replace({ name: key });
      } else {
        router.push({ name: key });
      }
    };

    const onLogin = (type) => {
      router.push({ name: "login", params: { type: `type=${type}` } });
    };

    const onUserOperate = ({ key }) => {
      console.log(`Click on item ${key}`);
      if (key == "user" || key == "pay") {
        router.push({
          name: key,
          query: {
            ...route.query,
          },
        });
      } else if (key == "exit") {
        console.log(route.name);
        console.log(route.query);
        console.log(["feedBack", "user", "pay"].includes(route.name));

        LocalStoreAPI.remove("ACCESS_TOKEN");
        LocalStoreAPI.remove("USER_INFO");
        useStoreMain.setUserAndDynamicRouter(null, router);
        
        if (["feedBack", "user", "pay"].includes(route.name)) {
          router.push({
            // name: "homepage",
            name: "rebarMaterials",
            query: {
              ...route.query,
            },
          });
        } else {
          router.go(0);
        }
        $message.success("Logged out‌");
      }
    };

    const contactUs = ref(null);
    const handlecontactUs = () => {
      contactUs.value.showModal();
    };

    return {
      login,
      windowWidth,
      menuItem,
      current,
      isLogin,
      userId,
      contactUs,
      backHome,
      routerJump,
      onLogin,
      onUserOperate,
      handlecontactUs,
    };
  },
};
</script>

<style lang="less" scoped>
.logo-box {
  text-align: center;
  .logo-img {
    // width: 100%;
    height: 64px;
  }
}
.user-info {
  margin-right: 100px;
}
.meun {
  display: flex;
  justify-content: space-between;
  
}

.user-info-text {
  margin-left: 8px;
}
.user-name {
  margin-right: 4px;
}
.login-btn {
  box-shadow: rgba(0, 0, 0, 0.08) 0px 4px 6px 0px,
    rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
}
.use-old-web {
  margin-right: 10px;
}
</style>